import { Component } from '@angular/core';

@Component({
  selector: 'elcia-filter-container',
  imports: [],
  templateUrl: './filter-container.html',
  styleUrl: './filter-container.scss',
})
export class FilterContainer {

}
